(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trSidebar', trSidebar);

  function trSidebar() {
    'ngInject';
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'SidebarController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/sidebar/sidebar.view.html',
    };
    return directive;
  }
})();
